import React from "react";
import PostPagination from "../utils/pagination.js";

import {
  List,
  TextField,
  Edit,
  Create,
  Datagrid,
  SimpleForm,
  DateField,
  DateInput,
  SelectInput,
  NumberField,
  NumberInput,
  Responsive,
  SelectArrayInput,
  ReferenceInput,
  ReferenceArrayInput,
  required,
  number,
  Toolbar,
  SaveButton,
  DeleteButton,
} from "react-admin";
import DateFnsUtils from "@date-io/date-fns";
import { format } from "date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";

export const ListIndisponibility = (props) => (
  <List
    title="Promo"
    {...props}
    bulkActions={false}
    pagination={<PostPagination />}
  >
    <Responsive
      medium={
        <Datagrid rowClick="edit">
          <StartDateField
            sortable={false}
            source="startDate"
            label="Start Date"
          />
          <EndDateField sortable={false} source="endDate" label="Rent Date" />
          <TextField sortable={false} label="Provider" source="provider.name" />
          <TextField
            sortable={false}
            label="cars"
            source="carResp.carWithInfo"
          />
        </Datagrid>
      }
    />
  </List>
);

const IndisponibilityName = ({ record }) => {
  // Prepare data in title compute
  record.providerId = record.provider.id;
  record.carId = record.carResp.id;
  return (
    <span>
    
    </span>
  );
};

const EndDateInput = ({ record = {} }) => {
  var thisDate = record.endDate
    ? new Date(record.endDate.slice(0, 19))
    : new Date();
  localStorage.setItem("endDate", thisDate.toDateString());
  const [selectedDate, setSelectedDate] = React.useState(thisDate);
  const handleDateChange = (date) => {
    record.endDate = date.toJSON();
    setSelectedDate(date);
    localStorage.setItem("endDate", date.toDateString());
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        disableToolbar
        variant="inline"
        margin="normal"
        label="Rent Date"
        value={selectedDate}
        onChange={handleDateChange}
        KeyboardButtonProps={{
          "aria-label": "change date",
        }}
        format="dd/MM/yyyy"
      />
    </MuiPickersUtilsProvider>
  );
};

const StartDateInput = ({ record = {} }) => {
  var thisDate = record.startDate
    ? new Date(record.startDate.slice(0, 19))
    : new Date();
  localStorage.setItem("startDate", thisDate.toDateString());
  const [selectedDate, setSelectedDate] = React.useState(thisDate);
  const handleDateChange = (date) => {
    record.startDate = date.toJSON();
    setSelectedDate(date);
    localStorage.setItem("startDate", date.toDateString());
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        disableToolbar
        variant="inline"
        margin="normal"
        label="Start Date"
        value={selectedDate}
        onChange={handleDateChange}
        KeyboardButtonProps={{
          "aria-label": "change date",
        }}
        format="dd/MM/yyyy"
      />
    </MuiPickersUtilsProvider>
  );
};

const EndDateField = ({ record = {} }) => {
  if (!record.endDate || !record.endDate.length) return "";

  return (
    <p class="MuiTypography-body1-122 MuiTypography-root-100">
      {format(new Date(record.endDate.slice(0, 19)), "dd/MM/yyyy")}
    </p>
  );
};

const StartDateField = ({ record = {} }) => {
  if (!record.startDate || !record.startDate.length) return "";

  return (
    <p class="MuiTypography-body1-122 MuiTypography-root-100">
      {format(new Date(record.startDate.slice(0, 19)), "dd/MM/yyyy")}
    </p>
  );
};

const CustomToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
    <DeleteButton />
  </Toolbar>
);

export const IndisponibilityEdit = (props) => (
  <Edit title={<IndisponibilityName />} {...props}>
    <SimpleForm redirect="list" toolbar={<CustomToolbar />}>
      <StartDateInput
        validate={required()}
        source="startDate"
        label="Start Date"
      />
      <EndDateInput validate={required()} source="endDate" label="Rent Date" />
      {localStorage.getItem("role") === "ROLE_ADMIN" && (
        <ReferenceInput
          validate={required()}
          label="Provider"
          source="providerId"
          reference="providers"
        >
          <SelectInput optionValue="id" optionText="name" />
        </ReferenceInput>
      )}
      <ReferenceInput
        validate={required()}
        label="Car Class"
        source="carId"
        reference="cars"
      >
        <SelectInput optionValue="id" optionText="carWithInfo" />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);

export const IndisponibilityCreate = (props) => (
  <Create title="Add promo" {...props}>
    <SimpleForm redirect="list">
     
      <StartDateInput
        validate={required()}
        source="startDate"
        label="Start Date"
      />
      <EndDateInput validate={required()} source="endDate" label="Rent Date" />
      {localStorage.getItem("role") === "ROLE_ADMIN" && (
        <ReferenceInput
          validate={required()}
          label="Provider"
          source="providerId"
          reference="providers"
        >
          <SelectInput optionValue="id" optionText="name" />
        </ReferenceInput>
      )}
      <ReferenceArrayInput
        validate={required()}
        label="Car Class"
        source="carId"
        reference="cars"
      >
        <SelectArrayInput optionValue="id" optionText="carWithInfo" />
      </ReferenceArrayInput>
    </SimpleForm>
  </Create>
);
